<template>
  <div>
    <DataTable :key="componentKey" :columns="columns" :data="data" :options="{order: [[1, 'desc']], dom:'ftr<&quot;dt-info&quot;ip>', pagingType: 'simple_numbers'}" class="table table-striped display map-table" width="100%" />
  </div>
</template>

<script>
import {
  ref, computed, watch, onBeforeMount,
} from 'vue';
import { useStore } from 'vuex';
import DataTable from 'datatables.net-vue3';
import DataTablesLib from 'datatables.net-bs5';

DataTable.use(DataTablesLib);

export default {

  components: {
    DataTable,
  },
  setup() {
    const store = useStore();
    // const data = ref([]);
    const renderTable = ref(false);
    const data = ref([]);
    const tableName = ref('');
    const columns = ref([]);
    const componentKey = ref(0);

    // forces a rerender of the table with new key - this is necessary to change the column names
    const forceRerender = () => {
      componentKey.value += 1;
    };

    function setTableData() {
      const dataType = store.getters.getDataType === 'vehicles' ? 'vehicle_count' : 'miles';

      const mapData = store.getters.getMapTableData;
      const fullDataArr = [];
      if (mapData) {
        mapData.forEach((obj) => {
          const dataArr = [];
          const countyState = `${obj.county_name}, ${obj.state_abbr}`;
          const selectedData = parseFloat(obj[dataType]).toLocaleString();
          dataArr.push(countyState, selectedData);
          fullDataArr.push(dataArr);
        });
        data.value = fullDataArr;
      }
    }

    function setTableColumns() {
      const dataType = store.getters.getDataType === 'vehicles' ? 'Vehicles' : 'Miles';

      const columnObj = [{
        data: 0,
        title: 'County',
      },
      {
        data: 1,
        title: dataType,
      }];
      columns.value = columnObj;
    }

    onBeforeMount(() => {
      forceRerender('before');
      setTableData();
      setTableColumns();
    });

    watch(() => store.getters.getDataType, () => {
      forceRerender();
      setTableData();
      setTableColumns();
    });
    return {
      data,
      mapDataType: computed(() => store.getters.getDataType),
      tableName,
      columns,
      renderTable,
      forceRerender,
      componentKey,
    };
  },
};
</script>
